export default __webpack_public_path__ + "static/media/EAST2520.34I-34669_-19258_0.fda41e7f.jpg";